module.exports = __webpack_public_path__ + "static/7-97b9a0e5007520e572d9d4b7057c62cf.jpg";